import { fetchPrivateApi } from '@/lib/api/apiServiceBase.ts';
import { TagWebDto, TagAssignmentRequest } from '@/features/dashboard/tags/types/TagWebDto.ts';
import { TaggableType } from '@/features/dashboard/tags/types/TaggableType.ts';

const tagsApi = {
  /** Create-or-get: returns the existing tag if the name already exists. */
  create: async (dto: TagWebDto): Promise<TagWebDto> => {
    return await fetchPrivateApi<TagWebDto>('POST', 'tags', dto);
  },
  update: async (id: string, dto: TagWebDto): Promise<TagWebDto> => {
    return await fetchPrivateApi<TagWebDto>('PUT', `tags/${id}`, dto);
  },
  getAll: async (): Promise<TagWebDto[]> => {
    return await fetchPrivateApi<TagWebDto[]>('GET', 'tags');
  },
  remove: async (id: string): Promise<void> => {
    return await fetchPrivateApi<void>('DELETE', `tags/${id}`);
  },
  assign: async (request: TagAssignmentRequest): Promise<void> => {
    return await fetchPrivateApi<void>('POST', 'tags/assign', request);
  },
  unassign: async (request: TagAssignmentRequest): Promise<void> => {
    return await fetchPrivateApi<void>('POST', 'tags/unassign', request);
  },
  getForTarget: async (
    targetType: TaggableType,
    targetId: string,
  ): Promise<TagWebDto[]> => {
    return await fetchPrivateApi<TagWebDto[]>(
      'GET',
      `tags/targets/${targetType}/${targetId}`,
    );
  },
};

export default tagsApi;
